// vista#607: roll up the agent's network services (Bind9 DNS, Kea DHCP, …)
// into a per-kind status for the Overview tile. One row per kind, carrying the
// WORST health_state across that kind's services (so a single down DHCP box
// shows the kind as down), plus a count and the first error seen.
//
// Pure (no React/deps) so it's unit-testable without rendering Overview.

const KIND_LABELS = {
  bind9: 'DNS',
  kea: 'DHCP',
};

// Coarse severity rank for "worst-of" rollup. Higher = worse.
export function serviceStateRank(state) {
  switch ((state || '').toLowerCase()) {
    case 'down':
    case 'critical':
    case 'unhealthy':
    case 'error':
      return 3;
    case 'degraded':
    case 'warning':
      return 2;
    case 'healthy':
    case 'ok':
    case 'up':
      return 1;
    default:
      return 0; // unknown / not-yet-polled
  }
}

export function kindLabel(kind) {
  return KIND_LABELS[kind] || kind || 'Service';
}

// services: [{ kind, health_state, last_error, ... }]
// → [{ kind, label, state, count, error }] sorted worst-first.
export function summarizeNetworkServices(services) {
  const list = Array.isArray(services) ? services : [];
  const byKind = new Map();
  for (const svc of list) {
    const kind = svc.kind || 'other';
    const cur = byKind.get(kind);
    if (!cur) {
      byKind.set(kind, { kind, label: kindLabel(kind), state: svc.health_state, count: 1, error: svc.last_error || null });
    } else {
      cur.count += 1;
      if (serviceStateRank(svc.health_state) > serviceStateRank(cur.state)) cur.state = svc.health_state;
      if (!cur.error && svc.last_error) cur.error = svc.last_error;
    }
  }
  return [...byKind.values()].sort((a, b) => serviceStateRank(b.state) - serviceStateRank(a.state));
}

// #610 review: gate the Overview tile on the per-org `networkServicesEnabled`
// flag (same flag the Services nav uses, UI_GUIDELINES §4.3 / S14-18) AND on
// having data — so a flag-off org with residual `network_services` rows doesn't
// still show the tile. Both conditions must hold.
export function showNetworkServicesTile(enabled, summaryCount) {
  return !!enabled && summaryCount > 0;
}
